var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInfoBar),expression:"showInfoBar"}],ref:"notifications",on:{"close":_vm.onClose}})}
var staticRenderFns = []

export { render, staticRenderFns }